import { FuseNavigationModelInterface } from '../core/components/navigation/navigation.model';

export class FuseNavigationModel implements FuseNavigationModelInterface {
    public model: any[];

    constructor() {
        this.model = [
            {
                'id': 'applications',
                'title': 'Applications',
                'translate': 'NAV.APPLICATIONS',
                'type': 'group',
                'icon': 'apps',
                'children': [
                    {
                        'id': 'orders',
                        'title': 'Orders',
                        'type': 'item',
                        'icon': 'shopping_cart',
                        'url': 'apps/e-commerce/orders',
                        'exactMatch': true
                    },
                    {
                        'id': 'calendar',
                        'title': 'Calendar',
                        'translate': 'NAV.CALENDAR',
                        'type': 'item',
                        'icon': 'today',
                        'url': '/apps/calendar'
                    },
                    {
                        'id': 'users',
                        'title': 'Contacts',
                        'translate': 'NAV.CONTACTS',
                        'type': 'item',
                        'icon': 'account_box',
                        'url': 'apps/users',
                    },
                    {

                    },
                    /** Logout button */
                    {
                        'id': 'logout',
                        'type': 'item',
                    }
                ]
            },
        ];
    }
}




// WEBPACK FOOTER //
// /vercel/path0/src/app/navigation/navigation.model.ts